import { LocalDate, LocalTime } from 'js-joda';

export const schema = {
  date: LocalDate,
  startTime: LocalTime,
  endTime: LocalTime,
};
